import React from "react";
import { legendItemStyle, legendStyle } from "./style";
import { useTranslation } from "react-i18next";
import { buildingMapStyle } from "../map/Constants";

const buildingLegendStyle = {
  ...legendStyle,
};

const BuildingHeightLegend = (props) => {
  const { t } = useTranslation();
  const isBuildingHeight = props.mapStyle === buildingMapStyle;

  return isBuildingHeight ? (
    <div style={buildingLegendStyle}>
      <div>
        <b>{t("policy.buildingHeight")}</b>
      </div>

      <div>
        <span style={legendItemStyle("hsl(210, 78%, 19%)")}></span>0 m
      </div>

      <div>
        <span style={legendItemStyle("hsl(209, 67%, 32%)")}></span>4 m
      </div>

      <div>
        <span style={legendItemStyle("hsl(126, 100%, 47%)")}></span>8 m
      </div>

      <div>
        <span style={legendItemStyle("hsl(59, 100%, 53%)")}></span>12 m
      </div>

      <div>
        <span style={legendItemStyle("hsl(35, 92%, 51%)")}></span>16 m
      </div>

      <div>
        <span style={legendItemStyle("hsl(0, 98%, 53%)")}></span>20 m
      </div>

      <div>
        <span style={legendItemStyle("hsl(0, 100%, 30%)")}></span>40+ m
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "100px",
            lineHeight: 1,
          }}
        >
          ©MapBox, ©OpenStreetMap
        </span>
      </div>
    </div>
  ) : null;
};

export default BuildingHeightLegend;
